import { Button } from "@mui/material";
import { auth } from "../components/firebase";

export const Signout = () => {
  return <Button onClick={() => auth.signOut()}>サインアウト</Button>;
};
